import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Cascader, message, Select, Spin } from 'antd';
import { SDrawer, SGeneralForms } from 'shj-components';
import {
    getEmployee,
    getProjectExternalEmployeeDetail,
    getRegionList,
    insertOrUpdateProjectExternalEmployee,
} from '@/services/externalPerson'
import { trimObj } from "@/utils/data.ts";
import { getVendorInfoList } from '@/services/workerManagement';
import { cloneDeep, isArray, map } from 'lodash-es';
import { getParentId } from '@/utils/common';
import { getEnums } from '@/services/homeService';
import { idRegExp, phoneRegExp } from '@/utils/regular';

const edit = (props: any) => {
    const { Option } = Select;
    const formRef = useRef<any>()
    const { visibleDrawer = false, title = '新增', record, closeDetails, getDetail } = props
    const [loading, setLoading] = useState(false);
    const [spinLoading, setSpinLoading] = useState(false);
    const [dataObj, setDataObj] = useState<any>({})
    const [ownerUserList, setOwnerUserList] = useState([] as any[]);
    const [provinceList, setProvinceList] = useState<any>([])
    const [vendorInfoList, setVendorInfoList] = useState<any>([])
    const id = record?.id
    useEffect(() => {
        if (visibleDrawer) {
            formRef.current?.onFormRef()?.resetFields();
            formRef?.current?.updateOptions();
            initFn()
            formRef.current?.updateState({
                workTypeList: cloneDeep(props.workTypeList)
            })
        }
    }, [visibleDrawer])
    useEffect(() => {
        if(provinceList.length && dataObj.censusRegisterAreaCode) {
            const idPath = getParentId(provinceList, dataObj.censusRegisterAreaCode)
            formRef.current?.onFormRef()?.setFieldValue('censusRegisterAreaCode', idPath?.reverse())
        }
    },[provinceList, dataObj])
    const initFn = () => {
        setSpinLoading(true)
        getProjectExternalEmployeeDetail({ id, labelFlag: true }).then(async (res: any) => {
            res.censusRegisterAreaCode = [res.censusRegisterAreaCode]
            formRef.current?.onFormRef()?.setFieldsValue({ ...res })
            setDataObj({ ...res })
            filterWorkTypeData(res?.workTypeIds)
            setSpinLoading(false)
            const vendorInfoList: any = await getVendorInfoList(1, 10, { });
            for (let index = 0; index < res.vendorInfoIds.length; index++) {
                const element = res.vendorInfoIds[index];
                if(!(vendorInfoList?.records.find(item => item.id == element))) {
                    vendorInfoList?.records.push({
                        name: res.vendorInfoNames.split(',')[index],
                        id: element
                    })
                }
            }
            onSearchOwnerUserList(res.ownerUserName);
            setVendorInfoList(vendorInfoList?.records || [])
        })
    }
    // 使用 useCallback 来记忆这个函数
    const onSearchVendorList = useCallback(async (value: string) => {
        const vendorInfoList: any = await getVendorInfoList(1, 10, { vendorCodeOrName: value});
        setVendorInfoList(vendorInfoList?.records || []);
    }, []);
    const onSubmit = (values) => {
        if (isArray(values.censusRegisterAreaCode)) {
            values.censusRegisterAreaCode = values.censusRegisterAreaCode[values.censusRegisterAreaCode.length - 1]
        }
        let formObj = {
            ...dataObj,
            ...values,
        }
        formObj = trimObj(formObj, 'trim');
        setLoading(true)
        insertOrUpdateProjectExternalEmployee({
            ...formObj
        }).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")
            getDetail()
            closeDetails()
        }
        ).catch(() => {
            setLoading(false)
        })
    };
    const getOptions = async (): Promise<any> => {
        return new Promise(async (resolve) => {
            const WorkerTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.worker.enums.WorkerTypeEnum")
            const provinceList = await getRegionList();
            setProvinceList(provinceList)
            resolve({
                sexList: [{ value: true, label: '男' }, { value: false, label: '女' }],
                WorkerTypeEnum,
            });
        });
    }
    const onSearchOwnerUserList = async (value) => {
        const ownerUserList = await await getEmployee(1, 10, {userNameKeyword: value});
        setOwnerUserList(ownerUserList)
    }
    const changeCascader = (_value, data) => {
        if(data) {
            formRef.current?.onFormRef()?.setFieldValue('censusRegisterAreaName', data[data.length -1].object.fullName);
        } else {
            formRef.current?.onFormRef()?.setFieldValue('censusRegisterAreaName', null);
        }
    }
    /**
 * 对通用选项进行处理
 * @param value 
 */
    const filterWorkTypeData = (value: any) => {
        const state = formRef.current?.getState?.()
        const newWorkTypeList = map(cloneDeep(state?.workTypeList), (item: any) => {
            if (value && Array.isArray(value) && value.length > 0) {
                if (value.length === 1 && (state?.workTypeList.find(item => item.id === value[0])).name === '项目经理'
                ) {
                    item.disabled = item.name === '项目经理' ? false : true
                } else {
                    item.disabled = item.name === '项目经理' ? true : false
                }
            } else {
                item.disabled = false
            }
            return item
        })
        formRef.current?.updateState({
            workTypeList: cloneDeep(newWorkTypeList)
        })
    }
    const filterOptionSearch = (input: string, option: any) => option.children.indexOf(input) >= 0
    return (
        <>
            <SDrawer
                width={800}
                title={id ? '编辑' : title}
                open={visibleDrawer}
                onClose={closeDetails}
                onSubmit={onSubmit}
                loading={loading}
                destroyOnClose
            >
                <Spin spinning={spinLoading}>
                    <SGeneralForms
                        ref={formRef}
                        layout="vertical"
                        httpOptionsFn={getOptions}
                        configs={[
                            {
                                title: '基本信息',
                                titleMode: 'drawer',
                                formItem: [
                                    { label: 'id', name: 'id', hidden: true },
                                    {label: 'censusRegisterAreaName', name: 'censusRegisterAreaName', hidden: true},
                                    {
                                        name: 'name',
                                        label: '姓名',
                                        required: true,
                                        spanCol: 12,
                                        comConfig: {
                                            maxLength: 20,
                                        },
                                    },
                                    {
                                        name: 'phone',
                                        label: '电话',
                                        spanCol: 12,
                                        required: true,
                                        type: 'inputNumber',
                                        rules: [{ required: true, message: '请输入电话号码', pattern: phoneRegExp }],
                                        comConfig: {
                                            maxLength: 20,
                                        },
                                    },
                                    {
                                        name: 'idCard',
                                        label: '身份证号',
                                        required: true,
                                        rules: [{ required: true, message: '请输入身份证号', pattern: idRegExp }],
                                        spanCol: 12,
                                        comConfig: {
                                            maxLength: 20,
                                        },
                                    },
                                    {
                                        name: 'sex',
                                        label: '性别',
                                        spanCol: 12,
                                        required: true,
                                        data: 'sexList',
                                        type: 'select',
                                    },
                                    {
                                        name: 'type',
                                        label: '人员类型',
                                        required: true,
                                        spanCol: 12,
                                        data: 'WorkerTypeEnum',
                                        type: 'select',
                                        comConfig: {
                                            fieldNames: {
                                                label: 'description',
                                                value: 'key'
                                            }
                                        }
                                    },
                                    {
                                        name: 'workTypeIds',
                                        label: '技能标签',
                                        required: true,
                                        spanCol: 12,
                                        data: 'workTypeList',
                                        type: 'select',
                                        comConfig: {
                                            mode: 'multiple',
                                            fieldNames: { label: 'name', value: 'id' },
                                            onChange: (value) => {
                                                filterWorkTypeData(value)
                                            }
                                        },
                                    },
                                    {
                                        name: 'ownerUserId', label: '推荐人', type: 'select', data: 'ownerUserList', spanCol: 12,
                                        children: (<Select showSearch={true} disabled={true}
                                            filterOption={filterOptionSearch}
                                            onSearch={onSearchOwnerUserList}
                                            placeholder={'请选择推荐人'}>
                                            {ownerUserList.length && ownerUserList.map((item: any) => (
                                                <Option key={item.ucenterUserId} userName={item.userName}
                                                    value={item.ucenterUserId}>
                                                    {item.userName}
                                                </Option>
                                            ))}
                                        </Select>)
                                    },
                                    {
                                        name: 'emergencyPhone',
                                        label: '紧急电话',
                                        spanCol: 12,
                                        maxLength: 12,
                                        type: 'inputNumber',
                                        rules: [{ message: '请输入紧急电话', pattern: phoneRegExp }],
                                    },
                                    {
                                        name: 'industryAge',
                                        label: '行业工龄',
                                        spanCol: 12,
                                        maxLength: 2,
                                        type: 'inputNumber',
                                        comConfig: {
                                            min: 1,
                                            max: 99,
                                            precision: 0
                                        }
                                    },
                                    {
                                        name: 'orderAbility',
                                        label: '接单能力',
                                        spanCol: 12,
                                        maxLength: 3,
                                        type: 'inputNumber',
                                        comConfig: {
                                            min: 1,
                                            max: 999,
                                            precision: 0
                                        }
                                    },
                                    {
                                        name: 'censusRegisterAreaCode',
                                        label: '户籍所在地',
                                        required: false,
                                        spanCol: 12,
                                        type: 'select',
                                        children:
                                            <Cascader options={provinceList} placeholder="请选择户籍所在地" fieldNames={{ label: 'label', value: 'id', children: 'children' }} onChange={changeCascader}/>
                                    },
                                    {
                                        name: 'vendorInfoIds',
                                        label: '承包商',
                                        spanCol: 12,
                                        children: <Select placeholder={'请选择承包商'} mode='multiple'
                                            fieldNames={{ label: 'name', value: 'id' }}
                                            options={vendorInfoList} showSearch
                                            onSearch={onSearchVendorList}
                                            filterOption={false} // 禁用本地过滤
                                            notFoundContent={null} // 搜索时不显示"无匹配结果"
                                        />,
                                    },
                                    {
                                        name: 'addressAddress',
                                        label: '居住地',
                                        spanCol: 12,
                                        comConfig: {
                                            maxLength: 30,
                                        },
                                    },
                                    {
                                        name: 'workExperience',
                                        label: '从业经历描述',
                                        spanCol: 12,
                                        comConfig: {
                                            maxLength: 100,
                                        },
                                    },
                                    
                                ],
                            },
                        ]}
                    />
                </Spin>
            </SDrawer>
        </>
    );
};
export default edit
